import React, { useEffect, useRef, useState } from 'react';

const RADIUS = 27;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

/** Floating scroll-to-top control with a progress ring around it. */
const BackToTop: React.FC = () => {
    const [visible, setVisible] = useState(false);
    const ref = useRef<HTMLButtonElement>(null);

    useEffect(() => {
        let frame = 0;

        const update = () => {
            frame = 0;
            const max = document.documentElement.scrollHeight - window.innerHeight;
            const ratio = max > 0 ? Math.min(window.scrollY / max, 1) : 0;
            ref.current?.style.setProperty('--progress', ratio.toFixed(4));
            setVisible(window.scrollY > 620);
        };

        const onScroll = () => {
            if (!frame) frame = requestAnimationFrame(update);
        };

        update();
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => {
            window.removeEventListener('scroll', onScroll);
            cancelAnimationFrame(frame);
        };
    }, []);

    return (
        <button
            ref={ref}
            type="button"
            className={`to-top ${visible ? 'is-visible' : ''}`}
            style={{ ['--circ' as string]: CIRCUMFERENCE }}
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            aria-label="Back to top"
            tabIndex={visible ? 0 : -1}
        >
            <svg className="to-top__ring" viewBox="0 0 58 58" aria-hidden="true">
                <circle className="track" cx="29" cy="29" r={RADIUS} />
                <circle className="fill" cx="29" cy="29" r={RADIUS} />
            </svg>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path
                    d="M12 19V5M12 5l-6 6M12 5l6 6"
                    stroke="currentColor"
                    strokeWidth="2.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        </button>
    );
};

export default BackToTop;
